/**
 * 公共素材库
 * author: liu.linhai
 * created on: 2018.11
 */
angular.module('resourceCenterMaterialsModule', [
    'resCenterPMLRouterModule',
    'publiMaterialLibraryLeftModule'
])
    .controller('resourceCenterMaterialsCtrl', ['$scope', 'trsHttpService', '$q', '$stateParams', '$element', 'modalDialog', 'trsspliceString', 'eidtIwoPersonalMaterialService', '$timeout', function($scope, trsHttpService, $q, $stateParams, $element, modalDialog, trsspliceString, eidtIwoPersonalMaterialService, $timeout) {
        initStatus();
        initData();

        /**
         * [initStatus 初始化状态]
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: '1',
                PAGESIZE: '20'
            };

            $scope.params = {
                'serviceid': 'mlf_sharedmaterial', // 服务名
                'methodname': 'querySharedmaterials', // 方法名
                'FileType': '', // 数据类型
                'Order': '0', // 0：按创建时间排序，1：显示名称排序
                'KeyWords': '', // 搜索内容
                'CurrPage': $scope.page.CURRPAGE,
                'PageSize': $scope.page.PAGESIZE
            };

            $scope.moreParams = {
                'serviceid': 'mlf_sharedmaterial', // 服务名
                'methodname': 'querySharedmaterials', // 方法名
                'FileType': '', // 数据类型
                'Order': '0', // 0：按创建时间排序，1：显示名称排序
                'KeyWords': '', // 搜索内容
                'CurrPage': 1,
                'PageSize': $scope.page.PAGESIZE,
                'count': 1,
            };

            $scope.status = {
                btnRights: [], // 权限按钮
                'checkboxHoverStatus': false,
                'isShow': '', // 列表单选框悬浮显示
                'showWay': false, // true：缩略图显示,false:列表显示
                'clearSearch': false, // 清除搜索按钮出现
                'SelectedElementsView': '', // 选中的元素 平铺
                'SelectedElementsList': '', // 选中的元素 列表
                moreCount: 0, // 点击加载更多的次数
                goTop: false,
                isSearch: false, // false清空搜索关键字
                isiframeshow: true,
                checkboxHoverStatus: '',
                copyCurrPage: 1,
                parentId: $stateParams.nodeid,
                isPublicMaterial: true,
            };
            $scope.data = {
                items: '', // 列表数据
                selectedArray: [], // 选择的列表数据
                keywords: '',
                kwSearch: '', // 文件夹内容搜索关键字
                fileTypes: [
                    { name: '全部', value: '' },
                    { name: '图片', value: '2' },
                    // { name: "文字", value: "1" },
                    { name: '视频', value: '3' },
                    { name: '音频', value: '5' }
                ],
                sortTypes: [{ // 排序方式
                    name: '文件名',
                    value: '1'
                }, {
                    name: '文件大小',
                    value: '3'
                }, {
                    name: '修改日期',
                    value: '0'
                }],
                uploadImgs: [],
                currFileSort: 0,
            };
        }

        /**
         * [selectedFileType description] 选择数据类型
         * @param  {[type]} fileType [description] 数据类型
         * @return {[type]}          [description]
         */
        $scope.selectedFileType = function(fileType) {
            $scope.params.FileType = $scope.moreParams.FileType = angular.copy(fileType.value);
            $scope.params.KeyWords = $scope.moreParams.KeyWords = '';
            $scope.params.CurrPage = $scope.page.CURRPAGE = '1';
            $scope.status.copyCurrPage = 1;
            $scope.status.isSearch = false;
            requestData();
        };

        /**
         * [selectAll 全选]
         * @return {[type]} [description]
         */
        $scope.selectAll = function() {
            if ($scope.data.selectedArray.length == $scope.data.items.length) {
                $scope.data.selectedArray = [];
            } else {
                $scope.data.selectedArray = [];
                for (var i in $scope.data.items) {
                    $scope.data.selectedArray.push($scope.data.items[i]);
                }
            }
        };

        /**
         * [search description] 搜索
         * @param  {[type]} ev [description] 键盘按键
         * @return {[type]}    [description]
         */
        $scope.search = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.params.KeyWords = $scope.moreParams.KeyWords = angular.copy($scope.data.keywords);
                if ($scope.data.keywords == '') {
                    $scope.status.clearSearch = false;
                } else {
                    $scope.status.clearSearch = true;
                }
                $scope.status.isSearch = true;
                requestData();
            }
        };

        /**
         * [singleSelect 单选]
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.singleSelect = function(item) {
            var n = $scope.data.selectedArray.indexOf(item);
            n > -1 ? $scope.data.selectedArray.splice(n, 1) : $scope.data.selectedArray.push(item);
        };

        /**
         * [watchSroll description] 监控滚动条
         * @return {[type]} [description]
         */
        function watchScroll() {
            $scope.status.requestMoreStatus = true;
            $element.find('.content_text_wrap').scroll(function() { // 做一个滚动到底部时请求更多的数据
                if (!$scope.status.showWay) {return;}
                $scope.status.goTop = $(this).scrollTop() > 20;
                if (Math.ceil($(this).scrollTop()) + Math.ceil($(this)[0].clientHeight) >= $(this)[0].scrollHeight && $scope.status.requestMoreStatus && $scope.data.items.length < $scope.page.ITEMCOUNT) {
                    $scope.requestMore();
                }
            });
        }

        /**
         * [goTop description] 加载更多后回到页面顶部
         * @return {[type]} [description]
         */
        $scope.goTop = function() {
            $('.content_text_wrap').animate({ scrollTop: 0 }, 'slow');
        };

        /**
         * [initData 初始化数据]
         * @return {[type]} [description]
         */
        function initData() {
            initRightBtn();
            requestData().then(function() {
                watchScroll();
            });
        }

        /**
         * [initRightBtn 获取管理员删除按钮状态]
         * @return {[type]} [description]
         */
        function initRightBtn() {
            var defer = $q.defer();
            var params = {
                'serviceid': 'mlf_metadataright',
                'methodname': 'queryOperKeysOfNormalModal',
                'Classify': 'source.materials',
                'ModalName': '资源中心'
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                // $scope.status.btnRights = data;
                angular.forEach(data, function(value, key) {
                    $scope.status.btnRights[value.OPERNAME] = value;
                });
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [requestData 获取公共素材库素材]
         * @return {[type]} [description]
         */
        function requestData() {
            var defer = $q.defer();
            $scope.data.selectedArray = [];
            if (!$scope.status.isSearch) {$scope.data.keywords = '';}
            var params = angular.copy($scope.params);
            if ($scope.status.showWay) {
                params = angular.copy($scope.moreParams);
                params.PageSize = params.count * params.PageSize;
            }
            params.CategoryId = $stateParams.nodeid;
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                $scope.data.items = addSrcImgUrl(data.DATA);
                $scope.data.items = data.DATA;
                $scope.page.PAGECOUNT = data.PAGER.PAGECOUNT; // 页数
                $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT; // 文件数量
                $scope.data.selectedArray = [];
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [addSrcImgUrl 增加SRCIMGURL字段，预览时使用]
         * @param {[type]} data [description]
         */
        function addSrcImgUrl(data) {
            for (var i = 0; i < data.length; i++) {
                data[i].SRCIMGURL = data[i].SRCPICURL;
            }
            return data;
        }

        /**
         * [filterText 过滤所选数据中指定的数据类型]
         * @param  {[type]} type [description]
         * @return {[type]}      [description]
         */
        function filterText(type, type1, type2) {
            var flag = false;
            for (var i = 0; i < $scope.data.selectedArray.length; i++) {
                if ($scope.data.selectedArray[i].FILETYPE != type && $scope.data.selectedArray[i].FILETYPE != type1 && $scope.data.selectedArray[i].FILETYPE != type2) {
                    flag = true;
                    break;
                }
            }
            return flag;
        }

        /**
         * [sortData description] 列表数据排序
         * @param  {[type]} sortType [description]
         * @return {[type]}          [description]
         */
        $scope.sortData = function(sortType) {
            $scope.data.currFileSort = sortType.value;
            $scope.params.Order = $scope.moreParams.Order = angular.copy(sortType.value);
            $scope.params.CurrPage = $scope.page.CURRPAGE = '1';
            $scope.status.copyCurrPage = 1;
            $scope.status.isSearch = false;
            requestData();
        };

        /** [editVideoInfo description]编辑视频信息 */
        $scope.editVideoInfo = function(e, item) {
            e.stopPropagation();
            eidtIwoPersonalMaterialService.editVideoInfo(item.VIDEOID, item.SHAREDMATERIALID).then(function() {
                requestData();
            });
        };

        /**
         * [showFileSize description] 显示文件大小
         * @param  {[type]} item [description] 当前文件
         * @return {[type]}      [description]
         */
        $scope.showFileSize = function(item) {
            if (angular.isDefined(item.FILESIZE) && parseInt(item.FILESIZE) != NaN && parseInt(item.FILESIZE) !== 0) {
                var fileSize = parseInt(item.FILESIZE),
                    unitArray;
                if (item.FILETYPE == '2') {
                    unitArray = ['KB', 'MB', 'GB'];
                } else {
                    unitArray = ['B', 'KB', 'MB', 'GB'];
                }
                var unit = unitArray[0];
                for (var i = 0; fileSize > 1000; i++) {
                    fileSize = fileSize / 1024;
                    unit = unitArray[i + 1];
                }
                if ((fileSize + '').indexOf('.') > -1) {
                    fileSize = Math.round(fileSize * 10) / 10;
                }
                return (fileSize + unit);
            } else {
                return '--';
            }
        };

        /**
         * [switchShow 切换显示方式]
         * @return {[type]} [description]
         */
        $scope.switchShow = function() {
            $scope.params.KeyWords = $scope.moreParams.KeyWords = '';
            $scope.status.showWay = !$scope.status.showWay;
            $scope.data.selectedArray = [];
            $scope.data.currFileSort = '0'; // 按修改时间排序
            $scope.status.isSearch = false;
            requestData(); // /999
        };

        /**
         * [selectPageNum 选择分页条数]
         * @return {[type]} [description]
         */
        $scope.selectPageNum = function() {
            $scope.params.CurrPage = $scope.page.CURRPAGE = '1';
            $scope.params.PageSize = $scope.page.PAGESIZE;
            $scope.status.copyCurrPage = 1;
            requestData();
        };

        /**
         * [pageChanged 跳转到下一页]
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.params.CurrPage = $scope.page.CURRPAGE;
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };

        /**
         * [jumpToPage description]跳转到指定页
         * @return {[type]} [description]
         */
        $scope.jumpToPage = function() {
            if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
            }
            $scope.page.CURRPAGE = $scope.status.copyCurrPage;
            $scope.params.CurrPage = $scope.status.copyCurrPage;
            requestData();
        };

        /**
         * [deleteMaterial 删除素材]
         * @param  {Boolean} isAdmin [是否为管理员]
         * @return {[type]}          [description]
         */
        $scope.deleteMaterial = function(isAdmin, item) {
            modalDialog.confirmModal('删除', '确认删除公共素材文件', function() {
                var params = {
                    serviceid: 'mlf_sharedmaterial',
                    methodname: 'deleteSharedMaterials',
                    MaterialIds: !!item ? item.SHAREDMATERIALID : trsspliceString.spliceString($scope.data.selectedArray, 'SHAREDMATERIALID', ','),
                    IsAdminDelete: isAdmin == 1
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    if (data.ISSUCCESS === 'true') {
                        modalDialog.alertType('删除公共素材成功', '', 'success', false, function() {
                            requestData();
                        });
                    }
                });
            });
        };

        /**
         * [fetchPersonalMaterial 取至个人素材库]
         * @return {[type]} [description]
         */
        $scope.fetchPersonalMaterial = function() {
            eidtIwoPersonalMaterialService.moveFile($scope.data.selectedArray, false, function() {
                $scope.status.isSearch = false;
                requestData();
            }, '', true);
        };

        /**
         * [findChildrenFile description] 查看文件夹内的子文件，或文件详情
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.preview = function(item) {
            eidtIwoPersonalMaterialService.openFilePreview(item, function() {});
        };

        /**
         * [requestMore description]   视图模式点击加载更多
         * @return {[type]} [description]
         */
        $scope.requestMore = function() {
            $scope.status.requestMoreStatus = false;
            $scope.moreParams.count++;
            $scope.status.isSearch = false;
            requestData().then(function() {
                $timeout(function() {
                    $scope.status.requestMoreStatus = true;
                    if ($scope.page.ITEMCOUNT < $scope.moreParams.count * 20) {
                        $scope.status.requestMoreStatus = false;
                    }
                }, 500);
            });
        };

        /**
         * [upload description] 上传图片
         * @return {[type]} [description]
         */
        $scope.uploadImg = function() {
            var result = angular.copy($scope.data.uploadImgs);
            $scope.data.uploadImgs = [];
            var uploadImgList = [];
            for (var i = 0; i < result.length; i++) {
                uploadImgList.push({
                    ParentId: $stateParams.nodeid,
                    FileDesc: result[i].APPDESC,
                    FileName: result[i].APPFILE,
                    FileSize: result[i].APPSIZE + ''
                });
            }
            var params = {
                serviceid: 'mlf_sharedmaterial',
                methodname: 'addSharedMaterialOfImgs',
                SharedMaterialOfImgs: JSON.stringify(uploadImgList)
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                if (data.ISSUCCESS == 'true') {
                    $scope.params.CurrPage = $scope.page.CURRPAGE = '1';
                    $scope.status.copyCurrPage = 1;
                    $scope.status.isSearch = false;
                    requestData();
                }
            });
        };

        /** [funciton description]成功上传后执行的回调函数 */
        $scope.uploadVideo = function() {
            $scope.params.CurrPage = $scope.page.CURRPAGE = '1';
            $scope.status.copyCurrPage = 1;
            $scope.status.isSearch = false;
            requestData();
        };

        /**
         * [PushToFeiBian description] 推送到非编
         */
        $scope.PushToFeiBian = function() {
            var defer = $q.defer();
            if (filterText('3', '5')) {
                modalDialog.alertType('推送到非编工作站仅支持视频、音频格式', '', 'error', false);
                return;
            }
            var params = {
                serviceid: 'mlf_sharedmaterial',
                methodname: 'pushSharedMaterialsToFeiBianSite',
                sharedMaterialIds: trsspliceString.spliceString($scope.data.selectedArray, 'SHAREDMATERIALID', ',')
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                if (data.ISSUCCESS == 'true') {
                    modalDialog.alertType('已推送到非编工作站', '', 'success', false);
                    defer.resolve();
                    requestData();
                } else {
                    modalDialog.multiReportsAlert(data);
                    defer.resolve();
                    requestData();
                }
            });
            return defer.promise;
        };

        /**
         * [isPush description] 是否推送到非编
         * @param  {[object]}  item [description] 个人素材对象
         * @return {Boolean}      [description]
         */
        $scope.isPush = function(item) {
            if (angular.isDefined(item.ATTRIBUTE) && item.ATTRIBUTE.indexOf('ISPUSHFEIBIANWORKSITE') > -1) {
                return true;
            } else {
                return false;
            }
        };
    }]);
